

























































































































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import _ from "lodash";
import * as routes from "@/employee/route-names";
import {
  ReimbursementRequest,
  ExpenseEligibilityGroup
} from "@/shared/types";

import Button from "@/shared/components/ui/Button.vue";
import Widget from "@/shared/components/Widget.vue";
import ExpensesList from "@/employee/components/healthcareExpense/ExpensesList.vue";
import ExpenseEligibilitySelector from "@/shared/components/expense/ExpenseEligibilitySelector.vue";
import HowItWorks from "@/employee/components/healthcareExpense/HowItWorks.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import SideBar from "@/employee/components/healthcareExpense/SideBar.vue";
import HealthcareExpenseNavigation from "@/employee/components/healthcareExpense/HealthcareExpenseNavigation.vue";
import HealthcareExpensesAdd from "@/employee/components/healthcareExpense/HealthcareExpensesAdd.vue";
import BottomNotification from "@/shared/components/BottomNotification.vue";
import ReimburseMePopup from "@/employee/components/shared/ReimburseMePopup.vue";
import { formatCurrency } from "@/shared/currency";
import { useExpenseStore } from "@/employee/store/expense";
import { useExpenseBalanceSummaryStore } from "@/employee/store/expenseBalanceSummary";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useReimburseMeStore } from "@/employee/store/reimburseMe";

@Component({
  components: {
    Button,
    Widget,
    ExpensesList,
    HowItWorks,
    Pagination,
    ExpenseEligibilitySelector,
    SideBar,
    HealthcareExpenseNavigation,
    HealthcareExpensesAdd,
    BottomNotification,
    ReimburseMePopup,
  }
})
export default class HealthcareExpensesConfirmNew extends Vue {
  expenseStore = useExpenseStore();
  expenseBalanceSummaryStore = useExpenseBalanceSummaryStore();
  bankAccountStore = useBankAccountStore();
  custodianSettingsStore = useCustodianSettingsStore();
  reimburseMeStore = useReimburseMeStore();

  routes = routes;

  ExpenseEligibilityGroup = ExpenseEligibilityGroup;
  showPopup = false;
  unlikelyExpensesPanelOpen = false;

  showReimbursePopup = false;
  showExpenseAddView = false;
  formatCurrency = formatCurrency;

  @Prop() routeToSettings;
  @Prop() displayPersonalExpenseTracker: boolean;

  mounted () {
    if (this.custodianSettingsStore.showHealthcareExpensesV2) {
      this.$router.push({ name: routes.EligibleExpenses });
    }

    if (!this.custodianSettingsStore.allowReimbursement) {
      this.$router.push({ name: routes.HealthcareExpensesUnreimbursed });
    }

    this.expenseBalanceSummaryStore.loadState();
    this.expenseStore.getImportedExpenses();

    this.expenseStore.loadLikelyExpenses();
    this.expenseStore.loadPotentialExpenses();
    this.expenseStore.loadUnlikelyExpenses();
    this.bankAccountStore.loadBankAccountState();

    this.$on("tab-clicked", (event, tab) => {
      this.showExpenseAddView = false;
    });

    this.$on("close-add-expense", event => {
      this.showExpenseAddView = false;
    });

    setTimeout(() => {
      // this.showAdvisorNotification("You've saved <b>$248.00</b> in tax this year!");
    }, 5000);

  }

  bankNameToClass (name) {
    if (!name) return "";
    return name.toLowerCase().split(" ").join("");
  }

  get likelyExpensesPageButtonsStartValue () {
    return this.expenseStore.likelyExpensesPage - 2 > 0 ? this.expenseStore.likelyExpensesPage - 2 : 1;
  }

  get likelyExpensesPageButtonRange () {
    const endValue = this.expenseStore.likelyExpensesPage + 3 < this.expenseStore.likelyExpensesPageCount ?
        (this.expenseStore.likelyExpensesPage + 3) : (this.expenseStore.likelyExpensesPageCount + 1);
    return _.range(this.likelyExpensesPageButtonsStartValue, endValue);
  }

  switchLikelyExpensesPage (pageNumber): void {
    this.expenseStore.loadLikelyExpenses(pageNumber);
  }

  get potentialExpensesPageButtonsStartValue () {
    return this.expenseStore.potentialExpensesPage - 2 > 0 ? this.expenseStore.potentialExpensesPage - 2 : 1;
  }

  get potentialExpensesPageButtonRange () {
    const endValue = this.expenseStore.potentialExpensesPage + 3 < this.expenseStore.potentialExpensesPageCount ?
        (this.expenseStore.potentialExpensesPage + 3) : (this.expenseStore.potentialExpensesPageCount + 1);
    return _.range(this.potentialExpensesPageButtonsStartValue, endValue);
  }

  switchPotentialExpensesPage (pageNumber): void {
    this.expenseStore.loadPotentialExpenses(pageNumber);
  }

  get unlikelyExpensesPageButtonsStartValue () {
    return this.expenseStore.unlikelyExpensesPage - 2 > 0 ? this.expenseStore.unlikelyExpensesPage - 2 : 1;
  }

  get unlikelyExpensesPageButtonRange () {
    const endValue = this.expenseStore.unlikelyExpensesPage + 3 < this.expenseStore.unlikelyExpensesPageCount ?
        (this.expenseStore.unlikelyExpensesPage + 3) : (this.expenseStore.unlikelyExpensesPageCount + 1);
    return _.range(this.unlikelyExpensesPageButtonsStartValue, endValue);
  }

  get hasLinkedCards () {
    return this.bankAccountStore.linkedCards.length > 0;
  }

  get displayLinkCardSection () {
    return this.bankAccountStore.linkedCards.length === 0 && !this.bankAccountStore.linkedCardViewIsLoading;
  }

  switchUnlikelyExpensesPage (pageNumber): void {
    this.expenseStore.loadUnlikelyExpenses(pageNumber);
  }

  toggleUnlikelyExpensesPanel () {
    this.unlikelyExpensesPanelOpen = !this.unlikelyExpensesPanelOpen;
  }

  shortenBankCardNumber (length, cardNumber) {
    if (cardNumber.length > length) {
      return cardNumber.slice(cardNumber.length - length, cardNumber.length);
    } else {
      return cardNumber;
    }
  }


  get bottomNotificationButtonText (): string {
    return this.custodianSettingsStore.allowReimbursement ? "Reimburse Me" : "Save";
  }

  addExpenseAction (event: any) {
    event.preventDefault();
    this.showExpenseAddView = !this.showExpenseAddView;
  }

  handleNotificationClick (): void {
    if (this.custodianSettingsStore.allowReimbursement) {
      this.showReimbursePopup = true;
    } else {
      const params: ReimbursementRequest = {
        amount: this.reimburseAmount,
        reimbursementLinkedAccountId: 0,
        expenseIds: this.reimburseExpenseIds
      };
      this.reimburseMeStore.manualMarkedAsReimbursed(params);
    }
  }

  handleNotificationClose () {
    this.expenseBalanceSummaryStore.reimburseMeDismiss();
  }

  closeAll () {
    this.showReimbursePopup = false;
    this.expenseBalanceSummaryStore.reimburseMeDismiss();
  }

  get reimburseAmount () {
    return this.expenseBalanceSummaryStore.reimburseMeAmount.amount;
  }

  get reimburseExpenseIds () {
    return this.expenseBalanceSummaryStore.reimburseMeAmount.expenseIds;
  }

  get displayPilotExpenseTracker () {
    return this.expenseStore.importedExpenses.length > 0;
  }
}
